<div class="subscription-plan-container bg-[#EEF1F5] mt-[-48px] py-[24px] container-fluid">
  <div class="w-full max-w-[70rem] mx-auto">
    <h1 class="text-[20px] md:text-[24px] font-semibold leading-[36px] text-[#141E27] text-center">
      {{'Glamera_Subscription_Plans'|translate}}</h1>
    <p class="text-[13px] md:text-[15px] font-normal leading-[22.5px] text-[#6C7680] text-center">{{'Explore_our_plans'|translate}}</p>

    @if (isLoading()) {
    <app-subscription-paln-loading />
    }@else {
    <div
      class="bg-white rounded-[16px] border-[1px] border-solid border-[#DDE4EB] mt-[45px] relative pt-[53px] pb-[40px] mx-auto">

      <div class="absolute top-[0] left-[50%] flex gap-[6px]" style="transform: translate(-50%, -50%);">
        @for (button of plansService.subscriptionButtons; track $index) {
        <div (click)="selectedPlan.set(button.value)"
          [ngClass]="{'text-white bg-gradient-to-r from-[#7A5AF8] to-[#6938EF] button-active-shadow':selectedPlan() === button.value}"
          class="cursor-pointer  w-[max-content] h-[max-content] px-[16px] py-[8px] md:px-[24px] md:py-[9px] hover:text-[#6938EF] hover:border-[#6938EF] rounded-[6px] bg-[#FFFFFF] border-[1px] border-solid border-[#EEF1F5] text-[14px] md:text-[16px] font-medium leading-[24px] text-[#394551] button-shadow">
          {{button.name |translate}}
          @if (button.value === 'cycle360') {<span class="text-[13px] font-medium leading-[19.5px]">(Save 20%)</span>}
        </div>
        }
      </div>

      <!-- Carousel Container -->
      <div class="relative carousel-container">
        <!-- Navigation Controls (moved above the plans) -->
        <div class="flex justify-center items-center mb-3 space-x-4 carousel-controls">
          <!-- Previous Button -->
          <button 
            (click)="previousSlide()"
            [disabled]="currentSlide() === 0"
            class="p-2 rounded-full bg-white border border-gray-300 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors nav-button">
            @if (commonService.getLang() === 'ar') {
            <svg class="w-5 h-5 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"></path>
            </svg>
            } @else {
            <svg class="w-5 h-5 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"></path>
            </svg>
            }
          </button>

          <!-- Dots Indicator -->
          <div class="flex mx-1">
            @for (dot of getDotsArray(); track $index) {
            <button 
              (click)="goToSlide($index)"
              [class]="currentSlide() === $index ? 'w-8 bg-[#6938EF]' : 'w-2 bg-gray-300'"
              class="h-2 mx-1 rounded-full transition-all duration-300 dot-indicator"></button>
            }
          </div>

          <!-- Next Button -->
          <button 
            (click)="nextSlide()"
            [disabled]="currentSlide() >= getMaxSlide()"
            class="p-2 rounded-full bg-white border border-gray-300 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors nav-button">
            @if (commonService.getLang() === 'ar') {
            <svg class="w-5 h-5 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"></path>
            </svg>
            } @else {
            <svg class="w-5 h-5 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"></path>
            </svg>
            }
          </button>
        </div>

        <!-- Carousel Wrapper -->
        <div class="overflow-hidden carousel-wrapper">
          <div class="flex carousel-slide transition-transform duration-300 ease-in-out" 
               [style.transform]="getTransformValue()"
               (touchstart)="onTouchStart($event)"
               (touchend)="onTouchEnd($event)">
            @for (plan of plans(); track $index) {
            <div class="flex-shrink-0 px-3 md:px-6" [ngStyle]="{ width: (100 / itemsPerView()) + '%' }">
              <div class="bg-[#F5F7FA] rounded-[12px] border-[1px] border-solid border-[#DDE4EB] px-[16px] pt-[16px] pb-[32px] w-[313px] mx-auto">
                <h1 class="text-[20px] md:text-[24px] font-semibold leading-[36px] text-[#141E27] mb-[8px]"
                  [ngClass]="{'text-[#6938EF]':plan.isFeatured}">{{plan.name}}</h1>
                <h1 class="text-[28px] font-semibold leading-[42px] text-[#141E27] mb-[8px] inline">
                  {{plan[selectedPlan()]?.currency}}
                  @if (selectedPlan() === 'cycle30') {{{ (plan[selectedPlan()]?.price)?.toFixed(1) }}}
                  @else if (selectedPlan() === 'cycle360') {{{ ((plan[selectedPlan()]?.price || 0) / 12).toFixed(1) }}}
                </h1>
                <span class="text-[14px] font-normal leading-[21px] text-[#141E27] mb-[8px]">/
                  {{plansService.getPlanType('cycle30')|translate}}</span>
                <p class="text-[14px] font-normal leading-[21px] text-[#141E27] mb-[8px]" *ngIf="selectedPlan() !== 'cycle30'">
                  {{plan[selectedPlan()]?.currency}} {{plan[selectedPlan()]?.price || ''}} {{'translate_billed'|translate}}
                  {{plansService.getPlanType(selectedPlan())|translate}}</p>
                <p class="text-[14px] font-normal leading-[21px] text-[#141E27]">{{'translate_est_tax'|translate}}: 14%</p>

                <div class="border-b-[1px] border-solid border-[#DDE4EB] w-full mt-[24px] mb-[20px]"></div>

                @if (nonSubscribedBranches() && nonSubscribedBranches().length) {
                <button
                  [ngClass]="{'text-white bg-gradient-to-r from-[#7A5AF8] to-[#6938EF] button-active-shadow':plan.isFeatured}"
                  (click)="openPaymentMethodDialog(plan)"
                  class="cursor-pointer w-full py-[8px] rounded-[8px] bg-[#FFFFFF] border-[1px] border-solid border-[#6938EF] text-[16px] font-semibold leading-[24px] mb-[24px] text-[#6938EF] text-center">
                  {{'translate_subscribe_now' | translate}}</button>}

                <div style="max-height: 300px; overflow-y: auto;">
                @for (feature of plansService.getSortedFeatures(plan.features); track $index) {
                <div class="flex gap-[8px] mb-[16px]">
                  <div class="w-[20px] h-[20px] rounded-full text-[12px] flex justify-center items-center">
                    @if (feature?.featureIcon) {
                      <i [class]="feature.featureIcon + (feature?.isExist ? ' text-[#6938EF]' : ' text-[#9ba7ac]')"></i>
                    } @else {
                      <span [ngClass]="feature?.isExist ? 'text-[#6938EF]' : 'text-[#9ba7ac]'">
                        {{ feature?.isExist ? '✓' : '❌' }}
                      </span>
                    }
                  </div>

                  <p class="text-[12px] font-normal leading-[18px] text-[#000]">
                    {{ commonService.getLang() === 'ar' ? feature.nameAr : feature.nameEn }}
                  </p>
                  <!-- <p class="text-[12px] font-normal leading-[18px] text-[#000] cursor-help"
                    pTooltip="{{commonService.getLang() === 'ar'? feature.descriptionAr : feature.descriptionEn }}"
                    tooltipPosition="top">{{commonService.getLang() === 'ar'? '؟' : '?' }}</p> -->
                </div>
                }
                </div>
              </div>
            </div>
            }
          </div>
        </div>

      </div>

        <img src="../../../assets/Glamera-logo.png" alt="glamera logo" class="mx-auto mt-4 mb-3" />
        <p class="mt-[24px] text-[13px] font-normal leading-[19.5px] text-[#4A5662] w-full text-center mx-auto">{{'translate_change_policy'|translate}}</p>
        <p class="text-[13px] font-normal leading-[19.5px] text-[#4A5662] w-full text-center mx-auto">{{'translate_upgrade_description'|translate}}</p>
        <p class="text-[13px] font-normal leading-[19.5px] text-[#4A5662] w-full text-center mx-auto">{{'translate_downgrade_description'|translate}}</p>

    </div>
    }




    <h1 class="text-[20px] md:text-[24px] font-semibold leading-[36px] text-[#141E27] text-center mt-12">
      {{'ask_questions.Frequently_asked_questions'|translate}}</h1>
    <p class="text-[13px] md:text-[15px] font-normal leading-[22.5px] text-[#6C7680] text-center mb-12">
      {{'ask_questions.Frequently_asked_description'|translate}}</p>


    <p-accordion [activeIndex]="0"
      expandIcon="pi fa-solid fa-plus border-2 border-solid border-gray-400 rounded-full text-gray-400 h-5 w-5 flex justify-center items-center text-xs"
      collapseIcon="fa-solid fa-minus border-2 border-solid border-gray-400 rounded-full text-gray-400 h-5 w-5 flex justify-center items-center text-xs">
      <p-accordionTab iconPos="end" [header]="question.question |translate" *ngFor="let question of questions">
        <p class="text-[13px] md:text-[15px]">{{ question.answer|translate }}</p>
      </p-accordionTab>
    </p-accordion>


    <div class="my-20 py-5 px-3 md:px-5 rounded-2xl flex items-center gap-4 flex-col md:flex-row support-cta">
      <div class="flex-1 text-base md:text-2xl">
        <h1>{{'specific_question.Have_a_specific_question'|translate}}</h1>
        <h1 class="font-bold">{{'specific_question.Check_out_Our_Support_Center'|translate}}</h1>
      </div>
      <button type="button"
        (click)="navigateToContactUs()"
        class="bg-white/95 hover:bg-primary-600 hover:text-white text-gray-800 text-sm rounded-md py-3 px-8 cta-btn">
        {{'specific_question.Ask_a_Question'|translate}}</button>
    </div>
  </div>
</div>
<p-toast />
